import { useRouter } from "next/router";
import { NewsQuery, useNewsListQuery } from "@graphql/generated/graphql";
import { InfiniteList, NewsList } from "@components/core/infinite-list";
import { Trans } from "@lingui/macro";
import { useEffect, useRef } from "react";
import VodusSurvey, { VodusSurveyType } from "@components/shared/vodus-survey";

const NEWS_LIST_QUERY_TYPE = {
  latest: NewsQuery.Latest,
};

// Temp fix for scrollIntoView by adding fixed height, will come back to this later
const Loading = () => (
  <Trans>
    <p className="h-[1000px] py-4 text-center font-sen text-text-lightest">
      Loading...
    </p>
  </Trans>
);

const LandingPageNewsList = () => {
  const { query, locale } = useRouter();
  const abortControllerRef = useRef(new AbortController());
  const topic = Array.isArray(query.topic)
    ? query.topic[0]
    : query.topic == "Good_News"
    ? "Good News"
    : query.topic || "latest";
  const type = NEWS_LIST_QUERY_TYPE[topic] || NewsQuery.Category;
  const queryVariables = {
    type,
    categoryName: topic,
    limit: 20,
    languageCodes: [locale],
  };
  const { data, loading, fetchMore, error } = useNewsListQuery({
    variables: queryVariables,
    context: {
      fetchOptions: {
        signal: abortControllerRef.current.signal,
      },
    },
  });

  useEffect(() => {
    abortControllerRef.current = new AbortController();
  }, [topic]);

  return (
    <>
      {(loading || error) && <Loading />}
      {data && !error && (
        <InfiniteList
          infiniteLoadingOption={{
            dataLength: data.allNews.length || 0,
            next: () =>
              fetchMore({
                variables: {
                  ...queryVariables,
                  offset: data.allNews.length,
                },
              }),
            loader: <Loading />,
          }}
        >
          <NewsList
            news={data.allNews}
            hideGoodNewsLabel={topic === "Good News"}
            customNewsListItem={{
              index: 9,
              child: (
                <VodusSurvey
                  surveyType={VodusSurveyType.inline}
                  placeholder={
                    <hr className="-mb-4 mt-4 border-light-background" />
                  }
                />
              ),
            }}
          />
        </InfiniteList>
      )}
    </>
  );
};
export default LandingPageNewsList;
